import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Table,
  ButtonGroup,
  Button,
  InputGroup
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faBed,
  faMoneyBill,
  faPencilSquare,
  faPenToSquare,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { getLeaveProratesListByYear, updateSearch } from "../../3.Store/LeaveProratedSlice";
import { ThreeDots } from 'react-loader-spinner';
import { useSearchParams } from "react-router-dom";
import Pagination from "../../2.Commons/Pagination";

const EMPTY_LIST = [];

const LeaveProratedList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const role = JSON.parse(localStorage.getItem("roles"));
  const [searchParams] = useSearchParams();
  const year = searchParams.get('years');
  const page = searchParams.get('page');

  const getYearFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const year = params.get('years');
    return year ? parseInt(year) : new Date().getFullYear();
  };

  const getPageFromQuery = () => {
    const params = new URLSearchParams(location.search);
    console.log('Page:', params.get('page'));
    const page = params.get('page');
    return page ? parseInt(page) : 1;
  };

  const [selectedYear, setSelectedYear] = useState(getYearFromQuery());
  const proratesLists = useSelector(state => state.LeaveProratedSlice.proratesLists) || EMPTY_LIST;
  const search = useSelector((state) => state.LeaveProratedSlice.search);
  const { searchText } = search;
  const [loading, setLoading] = useState(false);

  //use to filter the table based on searchText
  const [filteredStaffList, setFilteredStaffList] = useState(proratesLists);

  const [currentPage, setCurrentPage] = useState(getPageFromQuery);
  const pageSize = 20; // Number of items per page
  const totalPages = Math.ceil(filteredStaffList.length / pageSize);

  useEffect(() => {
    setLoading(true);

    if (!role || !role.includes("HR-L-PRORATED")) {
      localStorage.clear();
      window.location.href = "/Login";
    }

    if (year && year !== 'null') {
      const parsedYear = parseInt(year);
      const parsedPage = parseInt(page);
      setSelectedYear(parsedYear);
      setCurrentPage(parsedPage);
      dispatch(getLeaveProratesListByYear({ year: parsedYear }))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      dispatch(getLeaveProratesListByYear({ year: selectedYear }))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [])

  useEffect(() => {
    setFilteredStaffList(
      proratesLists.filter(employee =>
        employee.employee.fullname.toLowerCase().includes(searchText.toLowerCase())
      )
    );
    // setCurrentPage(1);
  }, [proratesLists, searchText]);

  const handleBtnSearchYear = () => {
    // Check if the selected year is the current year
    setCurrentPage(1);
    const currentYear = new Date().getFullYear();
    console.log(currentYear, selectedYear);
    if (selectedYear !== currentYear) {
      // If not the current year, show the Swal popup
      Swal.fire({
        title: "You are editing prorates for year " + selectedYear,
        text: "Confirm to search?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          // Proceed with updating if the user confirmed
          submitUpdate();
        }
      });
    } else {
      // Proceed with the update if the year is the current year
      submitUpdate();
    }
  };

  const submitUpdate = () => {
    setLoading(true);
    dispatch(getLeaveProratesListByYear({ year: selectedYear }))
    .then(() => {
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
    });
  };

  const handleSearch = (e) => {
    setCurrentPage(1);
    const entity = {...search, searchText: e.target.value}
    console.log(entity)
    dispatch(updateSearch(entity));
  }

  const handleBtnBack = () => {
    navigate("/");
  };

  // const handleBtnCreate = () => {
  //   navigate(`/LeaveProratedForm?page=${currentPage}&years=${selectedYear}`);
  // };

  const handleClickView = (id) => {
    navigate(`/LeaveProratedForm/${id}?page=${currentPage}&years=${selectedYear}`)
  };

  const renderStaffList = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, filteredStaffList.length);
    
    return filteredStaffList.slice(startIndex, endIndex).map(employee => (
      <tr key={employee.id} style={{ cursor: "pointer" }}>
        {/* <td onClick={() => handleClickViewReport(employee.employee.id)}>{employee.employee.fullname}</td> */}
        <td>{moment(employee.created).format("YYYY-MM-DD")}</td>
        <td onClick={() => handleClickViewReport(employee.employee.id)}>
          {employee.employee.fullname
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')}
        </td>
        <td style={{ textAlign: "center" }}>
          {employee.prorate_type === 1
            ? "Join"
            : employee.prorate_type === -1
            ? "Resign"
            : "-"
          }
        </td>
        <td style={{ textAlign: "center" }}>{Math.abs(employee.prorated_leave_awarded).toFixed(1)}</td>
        <td style={{ textAlign: "center" }}>{Math.abs(employee.prorated_sickleave_awarded).toFixed(1)}</td>
        <td style={{ textAlign: "center" }}>{Math.abs(employee.prorated_medicalbenefit_awarded).toFixed(1)}</td>
        <td onClick={() => handleClickView(employee.id)} style={{ textAlign: "center" }}>
          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
        </td>
      </tr>
    ));
  };

  // Function to generate options for the dropdown menu
  const renderYearOptions = () => {
    const endYear = new Date().getFullYear() + 1; // One year ahead
    const startYear = endYear - 4;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push(
            <option key={year} value={year}>{year}</option>
        );
    }
    return years;
  };

  const handlePreviousPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const handleClickViewReport = (employeeId) => {
    navigate(`/HRLeaveReportForm/${employeeId}?year=${selectedYear}&type=prorates`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };  

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        
        <h1 className="TitleHeader">Leave Prorates</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <InputGroup className="mb-3">
          <Form.Select value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value))}>
              {renderYearOptions()}
          </Form.Select>
          <Button className="SearchIconBtn" onClick={handleBtnSearchYear}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroup>

        <InputGroup className="mb-3">
          <Form.Control 
            placeholder="Search by Employee Name" 
            value={searchText}
            onChange={handleSearch} 
          />
        </InputGroup>

        <hr className="hr-white " />

        <div style={{ overflowX: 'auto' }}>
          <Table borderless className="mt-3 my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "100px" }}>Prorate Date</th>
                <th style={{ width: "200px" }}>Employee</th>
                <th style={{ width: "100px", textAlign: "center" }}>Prorate Type</th>
                <th style={{ width: "60px", textAlign: "center" }}>
                  <FontAwesomeIcon icon={faLeaf} title="Annual Leave Entitled" />
                </th>
                <th style={{ width: "60px", textAlign: "center" }}>
                  <FontAwesomeIcon icon={faBed} title="Sick Leave Entitled" />
                </th>
                <th style={{ width: "60px", textAlign: "center" }}>
                  <FontAwesomeIcon icon={faMoneyBill} title="Medical Benefit Entitled" />
                </th>
                <th style={{ width: "30px", textAlign: "center" }}>
                  <FontAwesomeIcon icon={faPencilSquare} title="Action" />
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {filteredStaffList.length > 0 ? (
                  renderStaffList()
                ) : (
                  <tr>
                    <td colSpan="7">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          {/* <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnCreate}>
              Create
            </Button>
          </ButtonGroup> */}
        </div>
      </Card>
    </div>
  );
};
export default LeaveProratedList;